import template from './sw-cms-preview-product-heading.html.twig';
import './sw-cms-preview-product-heading.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
